"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rollbackInventoryLogs = exports.getInventoryLogs = exports.getProductInventoryLogCount = exports.updateInventoryLog = void 0;
const shared_1 = require("@getgreenline/shared");
const updateInventoryLog = (companyId, inventoryLogId, newLogType, subtype) => __awaiter(void 0, void 0, void 0, function* () {
    const postData = {
        newLogType,
    };
    if (subtype) {
        postData.subtype = subtype;
    }
    return shared_1.axios
        .post(`/api/v1/company/${companyId}/inventoryLog/${inventoryLogId}/modify`, postData)
        .then((response) => {
        const inventoryLog = response.data.inventoryLog;
        return inventoryLog;
    });
});
exports.updateInventoryLog = updateInventoryLog;
const getProductInventoryLogCount = (company, filter) => __awaiter(void 0, void 0, void 0, function* () {
    return shared_1.axios
        .get(`/api/v1/company/${company.id}/inventoryLog/inventoryLogCount`, {
        params: {
            startDate: filter.startDate,
            endDate: filter.endDate,
        },
    })
        .then((response) => {
        const inventoryLogCount = response.data;
        return inventoryLogCount;
    });
});
exports.getProductInventoryLogCount = getProductInventoryLogCount;
const getInventoryLogs = (companyId, filter = { limit: 30, offset: 0 }) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/company/${companyId}/eventLogs/inventory`, {
        params: filter,
    });
    return response.data;
});
exports.getInventoryLogs = getInventoryLogs;
const rollbackInventoryLogs = ({ companyId, locationId, logType, logTypeId, newCreateDate, }) => __awaiter(void 0, void 0, void 0, function* () {
    return shared_1.axios.patch(`/api/v2/admin/companies/${companyId}/locations/${locationId}/inventory-logs/types/${logType}/logtype-ids/${logTypeId}`, { newCreateDate });
});
exports.rollbackInventoryLogs = rollbackInventoryLogs;
//# sourceMappingURL=inventoryLog.js.map